import {setServer} from "../../utils/axios";
const request = setServer();

// 登录
export function setUserLogin(data) {
  return request({
    url: '/auth/toLogin',
    method: 'post',
    data: data,
  })
}

// 退出
export function setUserLogout(data) {
  return request({
    url: '/auth/logout',
    method: 'post',
    data: data
  })
}



// WEBPACK FOOTER //
// ./src/api/auth/index.js